import { Megaphone } from "lucide-react";

export const renderAnnouncementText = (text) =>
  text.split("\n").map((line, i, arr) => (
    <span key={i}>
      {line.split(/\*\*(.+?)\*\*/g).map((part, j) =>
        j % 2 === 1 ? <strong key={j} className="font-extrabold">{part}</strong> : part
      )}
      {i < arr.length - 1 && <br />}
    </span>
  ));

export const AnnouncementBanner = ({ text }) => (
  <div
    data-testid="worker-announcement"
    className="rounded-3xl border border-amber-500/40 bg-amber-400 px-6 py-5 shadow-lg shadow-amber-500/10 sm:px-8"
  >
    <div className="flex items-start gap-3.5">
      <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-500/60">
        <Megaphone className="h-4.5 w-4.5 text-amber-950" />
      </span>
      <div className="min-w-0">
        <p className="font-mono-label text-[10px] font-bold uppercase tracking-[0.25em] text-amber-900/70">Announcement from Melto</p>
        <p className="mt-1.5 text-sm font-medium leading-relaxed text-amber-950 sm:text-base">{renderAnnouncementText(text)}</p>
      </div>
    </div>
  </div>
);
